/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exclusive_VideoInputs */

const en_exclusive_video = /** @type {(inputs: Exclusive_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exclusive Video`)
};

const es_exclusive_video = /** @type {(inputs: Exclusive_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video exclusivo`)
};

const fr_exclusive_video = /** @type {(inputs: Exclusive_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vidéo exclusive`)
};

const de_exclusive_video = /** @type {(inputs: Exclusive_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exklusives Video`)
};

const ja_exclusive_video = /** @type {(inputs: Exclusive_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`限定ビデオ`)
};

const zh_exclusive_video = /** @type {(inputs: Exclusive_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`独家视频`)
};

const ar_exclusive_video = /** @type {(inputs: Exclusive_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فيديو حصري`)
};

const id_exclusive_video = /** @type {(inputs: Exclusive_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video Eksklusif`)
};

const it_exclusive_video = /** @type {(inputs: Exclusive_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video Esclusivo`)
};

const ru_exclusive_video = /** @type {(inputs: Exclusive_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Эксклюзивное видео`)
};

const pt_exclusive_video = /** @type {(inputs: Exclusive_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vídeo Exclusivo`)
};

const ko_exclusive_video = /** @type {(inputs: Exclusive_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`독점 비디오`)
};

/**
* | output |
* | --- |
* | "Exclusive Video" |
*
* @param {Exclusive_VideoInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const exclusive_video = /** @type {((inputs?: Exclusive_VideoInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exclusive_VideoInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_exclusive_video(inputs)
	if (locale === "es") return es_exclusive_video(inputs)
	if (locale === "fr") return fr_exclusive_video(inputs)
	if (locale === "de") return de_exclusive_video(inputs)
	if (locale === "ja") return ja_exclusive_video(inputs)
	if (locale === "zh") return zh_exclusive_video(inputs)
	if (locale === "ar") return ar_exclusive_video(inputs)
	if (locale === "id") return id_exclusive_video(inputs)
	if (locale === "it") return it_exclusive_video(inputs)
	if (locale === "ru") return ru_exclusive_video(inputs)
	if (locale === "pt") return pt_exclusive_video(inputs)
	return ko_exclusive_video(inputs)
});